// src/Profil/PodatkiUpnika/PodatkiUpnika.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../../api";
import "./PodatkiUpnika.css";

const OSNOVNE_BANKE = [
    "NLB d.d.",
    "OTP banka d.d.",
    "Banka Intesa Sanpaolo d.d.",
    "UniCredit Banka Slovenija d.d.",
    "Gorenjska banka d.d.",
    "Banka Sparkasse d.d.",
    "Delavska hranilnica d.d.",
    "Addiko Bank d.d.",
    "Deželna banka Slovenije d.d.",
    "Hranilnica LON d.d.",
    "Primorska hranilnica Vipava d.d.",
];

const MOZNOSTI_BANK = [...OSNOVNE_BANKE, "Druga banka"];

const normalizirajStevilo = (v) => {
    if (v == null || v === "") return null;

    const brezPresledkov = String(v).replace(/\s/g, "");
    let s = brezPresledkov;

    if (s.includes(",")) {
        s = s.replace(/\./g, "").replace(",", ".");
    } else if (s.includes(".")) {
        const dotIndex = s.indexOf(".");
        const decimals = s.length - dotIndex - 1;

        if (decimals === 3 && dotIndex <= s.length - 4) {
            s = s.replace(/\./g, "");
        }
    }

    const n = Number(s);
    return Number.isFinite(n) ? n : null;
};

const formatirajStevilo = (num) =>
    num == null
        ? ""
        : num.toLocaleString("sl-SI", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

const formatirajTrrVnos = (value) => {
    const digits = String(value || "")
        .replace(/\D/g, "")
        .slice(0, 17);

    return digits.replace(/(.{4})/g, "$1 ").trim();
};

const formatirajTelefonVnos = (value) => {
    let v = String(value || "");
    const imelZakljucekSPresledkom = /\s$/.test(v);

    v = v.replace(/[^\d+ ]/g, "");
    const imaZacetniPlus = v.trimStart().startsWith("+");
    v = v.replace(/\+/g, "");
    v = v.replace(/\s+/g, " ");
    v = v.replace(/^\s+/, "");

    if (imaZacetniPlus) v = "+" + v;

    const MAX_LEN = 20;
    if (v.length > MAX_LEN) v = v.slice(0, MAX_LEN);

    if (imelZakljucekSPresledkom && !v.endsWith(" ")) v += " ";

    return v;
};

export default function PodatkiUpnika() {
    const navigate = useNavigate();

    const [davcnaAliMaticna, setDavcnaAliMaticna] = useState("");
    const [nalaganje, setNalaganje] = useState(false);
    const [nalaganjeIzBaze, setNalaganjeIzBaze] = useState(false);
    const [napaka, setNapaka] = useState("");

    const [stranId, setStranId] = useState(null);
    const [gsmUpnika, setGsmUpnika] = useState("");
    const [ePostaUpnika, setEPostaUpnika] = useState("");
    const [napakePolj, setNapakePolj] = useState({});
    const [ajpesUpnik, setAjpesUpnik] = useState(null);

    const [zastopanPo, setZastopanPo] = useState("");
    const [pooblascenec, setPooblascenec] = useState("");
    const [glavnicaTerjatve, setGlavnicaTerjatve] = useState("");
    const [stevilkaSpisaIzvrsitelja, setStevilkaSpisaIzvrsitelja] = useState("");
    const [opravilnaStevilkaSodisca, setOpravilnaStevilkaSodisca] = useState("");
    const [imeIzvrsitelja, setImeIzvrsitelja] = useState("");
    const [trrUpnika, setTrrUpnika] = useState("");
    const [telefonUpnika, setTelefonUpnika] = useState("");
    const [kontaktnaOseba, setKontaktnaOseba] = useState("");

    const [statusUpnika, setStatusUpnika] = useState("koncni");
    const [davcniZavezanec, setDavcniZavezanec] = useState(false);
    const [opombe, setOpombe] = useState("");
    const [nazivNaRacun, setNazivNaRacun] = useState("");

    const [shranjevanje, setShranjevanje] = useState(false);
    const [sporociloShranjevanja, setSporociloShranjevanja] = useState("");

    const [nazivBanke, setNazivBanke] = useState("");
    const [poljubnaBanka, setPoljubnaBanka] = useState("");
    const [urejanjeObstojecega, setUrejanjeObstojecega] = useState(false);

    const normalizirajStevilke = (v) =>
        String(v || "").replace(/\D/g, "").slice(0, 10);

    useEffect(() => {
        let aktivno = true;

        (async () => {
            try {
                const res = await apiFetch("/api/auth/me");

                if (!res.ok) return;

                const data = await res.json();

                if (!aktivno) return;

                const polnoIme =
                    (data.fullName && data.fullName.trim()) ||
                    [data.firstName, data.lastName].filter(Boolean).join(" ").trim() ||
                    data.email ||
                    "";

                setImeIzvrsitelja((prej) => prej || polnoIme);
            } catch {
                // ignoriraj
            }
        })();

        return () => {
            aktivno = false;
        };
    }, []);

    const obravnavaSpremembeIskanja = (e) => {
        setNapaka("");
        setSporociloShranjevanja("");
        setAjpesUpnik(null);
        setUrejanjeObstojecega(false);
        setStranId(null);
        setDavcnaAliMaticna(normalizirajStevilke(e.target.value));
    };

    const obravnavaSpremembeOpravilneStevilke = (e) => {
        setOpravilnaStevilkaSodisca(e.target.value);
    };

    const obravnavaEnter = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();

            if (nalaganje || nalaganjeIzBaze) return;

            pridobiUpnika();
        }
    };

    const naloziUpnikaIzBazePoStevilki = async (stevke) => {
        setNalaganjeIzBaze(true);
        setSporociloShranjevanja("");
        setNapaka("");

        try {
            const params = new URLSearchParams();
            params.set("davcnaAliMaticna", stevke);

            const res = await apiFetch(`/api/stran/upnik?${params.toString()}`, {
                method: "GET",
            });

            if (res.status === 404) {
                setUrejanjeObstojecega(false);
                return false;
            }

            if (!res.ok) {
                let msg = "";

                try {
                    const json = await res.json();
                    msg = json?.message || json?.title || "";
                } catch {
                    msg = await res.text().catch(() => "");
                }

                throw new Error(msg || "Napaka pri pridobivanju podatkov iz baze.");
            }

            const data = await res.json();
            const pd = data.podatkiStrani || {};

            setStranId(data.id || null);
            setStevilkaSpisaIzvrsitelja(data.stevilkaSpisaIzvrsitelja || "");
            setOpravilnaStevilkaSodisca(data.opravilnaStevilkaSodisca || "");
            setDavcnaAliMaticna(pd.davcnaAliMaticna || "");
            setZastopanPo(pd.zastopanPo || "");
            setPooblascenec(pd.pooblascenec || "");
            setGlavnicaTerjatve(formatirajStevilo(pd.glavnicaTerjatve) || "");
            setImeIzvrsitelja((prej) => pd.izvrsitelj || prej);
            setStatusUpnika(pd.statusUpnika || "koncni");
            setDavcniZavezanec(Boolean(pd.davcniZavezanec));
            setOpombe(pd.opombe || "");
            setNazivNaRacun(pd.nazivNaRacun || "");

            if (pd.nazivBanke) {
                if (MOZNOSTI_BANK.includes(pd.nazivBanke)) {
                    setNazivBanke(pd.nazivBanke);
                    setPoljubnaBanka("");
                } else {
                    setNazivBanke("Druga banka");
                    setPoljubnaBanka(pd.nazivBanke);
                }
            } else {
                setNazivBanke("");
                setPoljubnaBanka("");
            }

            setTrrUpnika(formatirajTrrVnos(pd.trr || ""));
            setTelefonUpnika(formatirajTelefonVnos(pd.telefon || ""));
            setKontaktnaOseba(pd.kontaktnaOseba || "");
            setGsmUpnika(formatirajTelefonVnos(pd.gsm || ""));
            setEPostaUpnika(pd.ePosta || "");
            setAjpesUpnik(pd.ajpesUpnik || null);

            setUrejanjeObstojecega(true);
            setSporociloShranjevanja(
                "Shranjeni podatki upnika so naloženi iz baze. Uredite jih in shranite."
            );

            return true;
        } catch (e) {
            setSporociloShranjevanja(
                e?.message || "Napaka pri nalaganju podatkov iz baze."
            );
            setUrejanjeObstojecega(false);
            return false;
        } finally {
            setNalaganjeIzBaze(false);
        }
    };

    const pridobiIzAjpes = async () => {
        setNapaka("");
        setAjpesUpnik(null);
        setUrejanjeObstojecega(false);
        setStranId(null);

        const stevke = normalizirajStevilke(davcnaAliMaticna);

        if (!(stevke.length === 8 || stevke.length === 10)) {
            setNapaka("Vpiši davčno (8) ali matično (10) številk.");
            return;
        }

        setDavcnaAliMaticna(stevke);
        setNalaganje(true);

        try {
            const res = await apiFetch(`/api/ajpes/prs/${stevke}`, {
                method: "GET",
            });

            if (!res.ok) {
                let msg = "";

                try {
                    const json = await res.json();
                    msg = json?.message || "";
                } catch {
                    msg = await res.text().catch(() => "");
                }

                throw new Error(msg || "AJPES poizvedba ni uspela.");
            }

            const data = await res.json();

            setAjpesUpnik(data);
            setNazivNaRacun((prej) => (prej.trim() ? prej : data?.naziv || ""));
        } catch (e) {
            setNapaka(e?.message || "Napaka pri AJPES poizvedbi.");
        } finally {
            setNalaganje(false);
        }
    };

    const pridobiUpnika = async () => {
        setSporociloShranjevanja("");
        setNapaka("");
        setUrejanjeObstojecega(false);
        setStranId(null);

        const stevke = normalizirajStevilke(davcnaAliMaticna);

        if (!stevke) {
            setSporociloShranjevanja("Vpiši davčno ali matično številko.");
            return;
        }

        if (!(stevke.length === 8 || stevke.length === 10)) {
            setNapaka("Vpiši davčno (8) ali matično (10) številk.");
            return;
        }

        setDavcnaAliMaticna(stevke);

        const nalozenoIzBaze = await naloziUpnikaIzBazePoStevilki(stevke);

        if (nalozenoIzBaze) return;

        await pridobiIzAjpes();
    };

    const koncniNazivBanke =
        nazivBanke === "Druga banka" && poljubnaBanka.trim()
            ? poljubnaBanka.trim()
            : nazivBanke;

    const glavnicaNum = normalizirajStevilo(glavnicaTerjatve);

    const shraniStran = async () => {
        if (shranjevanje) return;

        setShranjevanje(true);
        setSporociloShranjevanja("");
        setNapakePolj({});

        const stevke = normalizirajStevilke(davcnaAliMaticna);

        if (!stevke) {
            setShranjevanje(false);
            setSporociloShranjevanja("Vpiši davčno ali matično številko.");
            return;
        }

        if (!(stevke.length === 8 || stevke.length === 10)) {
            setShranjevanje(false);
            setSporociloShranjevanja("Vpiši davčno (8) ali matično (10) številk.");
            return;
        }

        if (!stevilkaSpisaIzvrsitelja.trim() && !opravilnaStevilkaSodisca.trim()) {
            setShranjevanje(false);
            setSporociloShranjevanja(
                "Vnesite št. spisa izvršitelja ali opr. št. sodišča."
            );
            return;
        }

        try {
            const ePostaTrim = (ePostaUpnika || "").trim();

            const payload = {
                id: urejanjeObstojecega ? stranId : null,
                stevilkaSpisaIzvrsitelja: stevilkaSpisaIzvrsitelja.trim(),
                opravilnaStevilkaSodisca: opravilnaStevilkaSodisca.trim(),
                podatkiStrani: {
                    davcnaAliMaticna: stevke,
                    zastopanPo: zastopanPo.trim(),
                    pooblascenec: pooblascenec.trim(),
                    glavnicaTerjatve: glavnicaNum,
                    izvrsitelj: imeIzvrsitelja,
                    nazivBanke: koncniNazivBanke,
                    trr: trrUpnika.replace(/\s/g, ""),
                    telefon: telefonUpnika.replace(/\s/g, ""),
                    kontaktnaOseba: kontaktnaOseba.trim(),
                    gsm: gsmUpnika.replace(/\s/g, ""),
                    ePosta: ePostaTrim === "" ? null : ePostaTrim,
                    ajpesUpnik,
                    statusUpnika,
                    davcniZavezanec,
                    opombe: opombe.trim(),
                    nazivNaRacun: nazivNaRacun.trim(),
                },
            };

            const res = await apiFetch("/api/stran/upnik", {
                method: "POST",
                body: payload,
            });

            if (!res.ok) {
                try {
                    const data = await res.json();
                    const errors = data?.errors || {};

                    const ePostaNapake = errors["PodatkiStrani.EPosta"];

                    if (ePostaNapake && ePostaNapake.length > 0) {
                        setNapakePolj((prej) => ({
                            ...prej,
                            ePosta: ePostaNapake[0],
                        }));
                        setSporociloShranjevanja("Popravi napake v označenih poljih.");
                        setShranjevanje(false);
                        return;
                    }

                    const keys = Object.keys(errors);

                    if (keys.length > 0) {
                        const firstKey = keys[0];
                        const firstError = errors[firstKey]?.[0];

                        setSporociloShranjevanja(
                            firstError ||
                            data?.message ||
                            data?.title ||
                            "Napaka pri shranjevanju podatkov o upniku."
                        );
                    } else {
                        setSporociloShranjevanja(
                            data?.message ||
                            data?.title ||
                            "Napaka pri shranjevanju podatkov o upniku."
                        );
                    }
                } catch {
                    setSporociloShranjevanja(
                        "Napaka pri shranjevanju podatkov o upniku."
                    );
                }

                setShranjevanje(false);
                return;
            }

            const saved = await res.json().catch(() => ({}));

            setDavcnaAliMaticna(stevke);
            setStranId(saved?.id || stranId);
            setUrejanjeObstojecega(true);
            setSporociloShranjevanja("Uspešno shranjeno.");
        } catch (e) {
            setSporociloShranjevanja(e?.message || "Napaka pri shranjevanju.");
        } finally {
            setShranjevanje(false);
        }
    };

    const imeUpnika = ajpesUpnik?.naziv || "";
    const naslovUpnika = ajpesUpnik?.naslov || "";
    const postaUpnika = ajpesUpnik?.posta || "";
    const drzavaUpnika = ajpesUpnik?.drzava || "";
    const davcnaStevilkaUpnika = ajpesUpnik?.davcnaStevilka || "";

    return (
        <main className="pu-page">
            <section className="pu-content">
                <div className="pu-card">
                    <div className="pu-cardHeader">
                        <div className="pu-cardHeader-brand">
                            <div className="pu-cardHeader-meta">
                                <h1 className="pu-cardHeader-title">Podatki o upniku</h1>
                                <p className="pu-cardHeader-subtitle">
                                    Pridobitev in dopolnitev podatkov o upniku in terjatvi.
                                </p>
                            </div>
                        </div>

                        <button
                            type="button"
                            className="btn-nazaj"
                            onClick={() => navigate("/profil", { replace: true })}
                            aria-label="Nazaj na profil"
                            title="Nazaj"
                        >
                            <span className="btn-nazaj__icon" aria-hidden="true">
                                ←
                            </span>
                        </button>
                    </div>

                    <section className="pu-section pu-topRowSection">
                        <div className="pu-topRow">
                            <label className="pu-inputs-gl">
                                <span className="pu-label globalniizv-label-icon-wrap">
                                    Izvršitelj
                                </span>
                                <input
                                    id="pu-izvrsitelj"
                                    name="izvrsitelj"
                                    className="pu-input pu-topLabel"
                                    value={imeIzvrsitelja}
                                    readOnly
                                />
                            </label>

                            <label className="pu-inputs-gl">
                                <span className="pu-label">Št. spisa izvršitelja</span>
                                <input
                                    id="pu-stevilkaSpisaIzvrsitelja"
                                    name="stevilkaSpisaIzvrsitelja"
                                    className="pu-input pu-topLabel"
                                    value={stevilkaSpisaIzvrsitelja}
                                    onChange={(e) =>
                                        setStevilkaSpisaIzvrsitelja(e.target.value)
                                    }
                                />
                            </label>

                            <label className="pu-inputs-gl">
                                <span className="pu-label">Opr. št. sodišča</span>
                                <input
                                    id="pu-opravilnaStevilkaSodisca"
                                    name="opravilnaStevilkaSodisca"
                                    className="pu-input pu-topLabel"
                                    value={opravilnaStevilkaSodisca}
                                    onChange={obravnavaSpremembeOpravilneStevilke}
                                />
                            </label>
                        </div>
                    </section>

                    <section className="pu-grid">
                        <div className="pu-gridCol pu-gridCol--left">
                            <div className="pu-section pu-section--upnik">
                                <h3 className="pu-sectionTitle">Iskanje upnika v AJPES PRS</h3>

                                <div className="pu-formBlock">
                                    <div className="pu-formRow pu-formRow--search">
                                        <label className="pu-inputs-gl pu-inputs-gl--search">
                                            <span className="pu-label">
                                                Matična ali davčna številka (24995975)
                                            </span>
                                            <input
                                                id="pu-davcnaAliMaticna"
                                                name="davcnaAliMaticna"
                                                className="pu-input"
                                                value={davcnaAliMaticna}
                                                onChange={obravnavaSpremembeIskanja}
                                                onKeyDown={obravnavaEnter}
                                                inputMode="numeric"
                                            />
                                        </label>

                                        <div className="pu-formSearchAction">
                                            <button
                                                type="button"
                                                className="pu-btn"
                                                onClick={pridobiUpnika}
                                                disabled={nalaganje || nalaganjeIzBaze}
                                            >
                                                {nalaganje || nalaganjeIzBaze
                                                    ? "Iskanje…"
                                                    : "Pridobi podatke"}
                                            </button>
                                        </div>
                                    </div>

                                    {napaka && (
                                        <div className="pu-alert pu-alert--error">
                                            {napaka}
                                        </div>
                                    )}
                                </div>

                                <div className="pu-formBlock pu-formBlock--identity">
                                    <div className="pu-formRow pu-formRow--single">
                                        <label className="pu-inputs-gl">
                                            <span className="pu-label">Naziv upnika</span>
                                            <input
                                                id="pu-nazivUpnika"
                                                name="nazivUpnika"
                                                className="pu-input pu-input--readonly"
                                                value={imeUpnika}
                                                readOnly
                                                placeholder="— podatki še niso pridobljeni —"
                                            />
                                        </label>
                                    </div>

                                    <div className="pu-formRow pu-formRow--single">
                                        <label className="pu-inputs-gl">
                                            <span className="pu-label">Naslov</span>
                                            <input
                                                id="pu-naslovUpnika"
                                                name="naslovUpnika"
                                                className="pu-input pu-input--readonly"
                                                value={naslovUpnika}
                                                readOnly
                                                placeholder="— podatki še niso pridobljeni —"
                                            />
                                        </label>
                                    </div>

                                    <div className="pu-formRow pu-formRow--single">
                                        <label className="pu-inputs-gl">
                                            <span className="pu-label">
                                                Pošta / država / davčna št.
                                            </span>
                                            <div className="pu-inlineInputs">
                                                <input
                                                    id="pu-postaUpnika"
                                                    name="postaUpnika"
                                                    className="pu-input pu-input--readonly"
                                                    value={postaUpnika}
                                                    readOnly
                                                    placeholder="Pošta"
                                                />
                                                <input
                                                    id="pu-drzavaUpnika"
                                                    name="drzavaUpnika"
                                                    className="pu-input pu-input--readonly"
                                                    value={drzavaUpnika}
                                                    readOnly
                                                    placeholder="Država"
                                                />
                                                <input
                                                    id="pu-davcnaStevilkaUpnika"
                                                    name="davcnaStevilkaUpnika"
                                                    className="pu-input pu-input--readonly"
                                                    value={davcnaStevilkaUpnika}
                                                    readOnly
                                                    placeholder="Davčna št."
                                                />
                                            </div>
                                        </label>
                                    </div>

                                    <div className="pu-formRow pu-formRow--single">
                                        <label className="pu-inputs-gl">
                                            <span className="pu-label">
                                                E-pošta
                                                {napakePolj.ePosta && (
                                                    <span className="pu-fieldError">
                                                        {" "}
                                                        – {napakePolj.ePosta}
                                                    </span>
                                                )}
                                            </span>
                                            <input
                                                id="pu-ePostaUpnika"
                                                name="ePostaUpnika"
                                                className={`pu-input${napakePolj.ePosta
                                                        ? " pu-input--error"
                                                        : ""
                                                    }`}
                                                type="email"
                                                value={ePostaUpnika}
                                                onChange={(e) => {
                                                    setEPostaUpnika(e.target.value);
                                                    setNapakePolj((prej) => ({
                                                        ...prej,
                                                        ePosta: undefined,
                                                    }));
                                                }}
                                            />
                                        </label>
                                    </div>
                                </div>

                                <div className="pu-formBlock pu-formBlock--options">
                                    <div className="pu-formRow pu-formRow--status">
                                        <label className="pu-inputs-gl pu-optionCard">
                                            <span className="pu-label pu-optionCard__title">
                                                Status upnika
                                            </span>
                                            <div
                                                className="pu-radioGrid pu-radioGrid--status"
                                                role="radiogroup"
                                                aria-label="Status upnika"
                                            >
                                                <label className="pu-radioLabel">
                                                    <input
                                                        type="radio"
                                                        name="statusUpnika"
                                                        value="koncni"
                                                        checked={statusUpnika === "koncni"}
                                                        onChange={(e) =>
                                                            setStatusUpnika(e.target.value)
                                                        }
                                                    />
                                                    Končni potrošnik
                                                </label>

                                                <label className="pu-radioLabel">
                                                    <input
                                                        type="radio"
                                                        name="statusUpnika"
                                                        value="eu_id"
                                                        checked={statusUpnika === "eu_id"}
                                                        onChange={(e) =>
                                                            setStatusUpnika(e.target.value)
                                                        }
                                                    />
                                                    Upnik iz EU z ID-številko
                                                </label>

                                                <label className="pu-radioLabel">
                                                    <input
                                                        type="radio"
                                                        name="statusUpnika"
                                                        value="zavezanec_id"
                                                        checked={statusUpnika === "zavezanec_id"}
                                                        onChange={(e) =>
                                                            setStatusUpnika(e.target.value)
                                                        }
                                                    />
                                                    Zavezanec za DDV z ID-številko
                                                </label>

                                                <label className="pu-radioLabel">
                                                    <input
                                                        type="radio"
                                                        name="statusUpnika"
                                                        value="drugo"
                                                        checked={statusUpnika === "drugo"}
                                                        onChange={(e) =>
                                                            setStatusUpnika(e.target.value)
                                                        }
                                                    />
                                                    Drugo
                                                </label>
                                            </div>
                                        </label>

                                        <label className="pu-inputs-gl pu-optionCard pu-optionCard--compact">
                                            <span className="pu-label pu-optionCard__title">
                                                Davčni zavezanec
                                            </span>
                                            <div
                                                className="pu-radioGrid pu-radioGrid--binary"
                                                role="radiogroup"
                                                aria-label="Davčni zavezanec"
                                            >
                                                <label className="pu-radioLabel">
                                                    <input
                                                        type="radio"
                                                        name="davcniZavezanec"
                                                        checked={davcniZavezanec === true}
                                                        onChange={() => setDavcniZavezanec(true)}
                                                    />
                                                    Da
                                                </label>

                                                <label className="pu-radioLabel">
                                                    <input
                                                        type="radio"
                                                        name="davcniZavezanec"
                                                        checked={davcniZavezanec === false}
                                                        onChange={() => setDavcniZavezanec(false)}
                                                    />
                                                    Ne
                                                </label>
                                            </div>
                                        </label>
                                    </div>
                                </div>

                                <div className="pu-formBlock">
                                    <div className="pu-formRow pu-formRow--2">
                                        <label className="pu-inputs-gl">
                                            <span className="pu-label">Pooblaščenec</span>
                                            <input
                                                id="pu-pooblascenec"
                                                name="pooblascenec"
                                                className="pu-input"
                                                value={pooblascenec}
                                                onChange={(e) =>
                                                    setPooblascenec(e.target.value)
                                                }
                                            />
                                        </label>

                                        <label className="pu-inputs-gl">
                                            <span className="pu-label">
                                                Znesek terjatve – glavnica
                                            </span>
                                            <div className="pu-inputCurrency">
                                                <input
                                                    id="pu-glavnicaTerjatve"
                                                    name="glavnicaTerjatve"
                                                    className="pu-input"
                                                    type="text"
                                                    inputMode="decimal"
                                                    placeholder="npr. 1.000,00"
                                                    value={glavnicaTerjatve}
                                                    onChange={(e) => {
                                                        const raw = e.target.value;
                                                        const cleaned = raw.replace(
                                                            /[^0-9.,]/g,
                                                            ""
                                                        );
                                                        setGlavnicaTerjatve(cleaned);
                                                    }}
                                                    onBlur={(e) => {
                                                        const num = normalizirajStevilo(
                                                            e.target.value
                                                        );
                                                        const formatted = formatirajStevilo(num);
                                                        setGlavnicaTerjatve(formatted);
                                                    }}
                                                />
                                                <span className="pu-inputCurrency__suffix">€</span>
                                            </div>
                                        </label>
                                    </div>

                                    <div className="pu-formRow pu-formRow--2">
                                        <label className="pu-inputs-gl">
                                            <span className="pu-label">Banka</span>
                                            <div className="pu-bankRow">
                                                <select
                                                    id="pu-nazivBanke"
                                                    name="nazivBanke"
                                                    className="pu-input"
                                                    value={nazivBanke}
                                                    onChange={(e) => {
                                                        const v = e.target.value;
                                                        setNazivBanke(v);
                                                        if (v !== "Druga banka") {
                                                            setPoljubnaBanka("");
                                                        }
                                                    }}
                                                >
                                                    <option value="">- izberi banko</option>
                                                    {MOZNOSTI_BANK.map((b) => (
                                                        <option key={b} value={b}>
                                                            {b}
                                                        </option>
                                                    ))}
                                                </select>

                                                {nazivBanke === "Druga banka" && (
                                                    <input
                                                        id="pu-poljubnaBanka"
                                                        name="poljubnaBanka"
                                                        className="pu-input"
                                                        value={poljubnaBanka}
                                                        onChange={(e) =>
                                                            setPoljubnaBanka(e.target.value)
                                                        }
                                                        placeholder="Vpiši naziv banke"
                                                    />
                                                )}
                                            </div>
                                        </label>

                                        <label className="pu-inputs-gl">
                                            <span className="pu-label">Kontaktna oseba</span>
                                            <input
                                                id="pu-kontaktnaOseba"
                                                name="kontaktnaOseba"
                                                className="pu-input"
                                                value={kontaktnaOseba}
                                                onChange={(e) =>
                                                    setKontaktnaOseba(e.target.value)
                                                }
                                            />
                                        </label>
                                    </div>

                                    <div className="pu-formRow pu-formRow--2">
                                        <label className="pu-inputs-gl">
                                            <span className="pu-label">GSM</span>
                                            <input
                                                id="pu-gsmUpnika"
                                                name="gsmUpnika"
                                                className="pu-input"
                                                type="tel"
                                                inputMode="tel"
                                                pattern="[0-9+ ]*"
                                                value={gsmUpnika}
                                                onChange={(e) =>
                                                    setGsmUpnika(
                                                        formatirajTelefonVnos(e.target.value)
                                                    )
                                                }
                                            />
                                        </label>

                                        <label className="pu-inputs-gl">
                                            <span className="pu-label">Kontakt</span>
                                            <input
                                                id="pu-telefonUpnika"
                                                name="telefonUpnika"
                                                className="pu-input"
                                                type="tel"
                                                inputMode="tel"
                                                pattern="[0-9+ ]*"
                                                value={telefonUpnika}
                                                onChange={(e) =>
                                                    setTelefonUpnika(
                                                        formatirajTelefonVnos(e.target.value)
                                                    )
                                                }
                                            />
                                        </label>
                                    </div>

                                    <div className="pu-formRow pu-formRow--2">
                                        <label className="pu-inputs-gl">
                                            <span className="pu-label">TRR</span>
                                            <div className="pu-ibanWrapper">
                                                <span className="pu-ibanPrefix">SI</span>
                                                <input
                                                    id="pu-trrUpnika"
                                                    name="trrUpnika"
                                                    className="pu-input pu-ibanInput"
                                                    inputMode="numeric"
                                                    placeholder="56 0000 0000 0000 000"
                                                    value={trrUpnika}
                                                    onChange={(e) =>
                                                        setTrrUpnika(
                                                            formatirajTrrVnos(e.target.value)
                                                        )
                                                    }
                                                />
                                            </div>
                                        </label>

                                        <label className="pu-inputs-gl">
                                            <span className="pu-label">Zastopan po</span>
                                            <input
                                                id="pu-zastopanPo"
                                                name="zastopanPo"
                                                className="pu-input"
                                                value={zastopanPo}
                                                onChange={(e) =>
                                                    setZastopanPo(e.target.value)
                                                }
                                            />
                                        </label>
                                    </div>
                                </div>

                                <div className="pu-formBlock">
                                    <div className="pu-formRow pu-formRow--single">
                                        <label className="pu-inputs-gl">
                                            <span className="pu-label">Opombe</span>
                                            <textarea
                                                id="pu-opombe"
                                                name="opombe"
                                                className="pu-input pu-textarea"
                                                rows={3}
                                                value={opombe}
                                                onChange={(e) => setOpombe(e.target.value)}
                                            />
                                        </label>
                                    </div>

                                    <div className="pu-formRow pu-formRow--single">
                                        <div className="pu-inputs-gl">
                                            <span className="pu-label">
                                                Naziv, ki se napiše na račun, avans, dobropis
                                            </span>

                                            <textarea
                                                id="pu-nazivNaRacun"
                                                name="nazivNaRacun"
                                                className="pu-input pu-textarea"
                                                rows={3}
                                                value={nazivNaRacun}
                                                onChange={(e) =>
                                                    setNazivNaRacun(e.target.value)
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <div className="pu-actionsRow">
                        {sporociloShranjevanja && (
                            <span className="pu-actionsMsg">
                                {sporociloShranjevanja}
                            </span>
                        )}

                        <button
                            type="button"
                            className="pu-btn"
                            onClick={shraniStran}
                            disabled={shranjevanje}
                        >
                            {shranjevanje
                                ? "Shranjujem…"
                                : urejanjeObstojecega
                                    ? "Posodobi"
                                    : "Shrani"}
                        </button>
                    </div>
                </div>
            </section>
        </main>
    );
}